export const CONSTANTS = {
    HOME_ICON_SIZE: 60,
    HOME_ICON_MAGNIFY: 2,
    HOME_SCREEN_COLOR: "rgb(90,90,200)",
    ROTATING_HEAD_INTERVAL: 50,
    ROTATING_DEMOREEL_INTERVAL: 60,
    FALLINGPHONE_INTERVAL: 50,
    FEELINGOK_WIDTH: 500
}